export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-2-480-af682cf9ae4630bd37e5156e133a3932.png";